module.exports = __webpack_public_path__ + "img/1-3.3ee53207.jpg";